import { render, staticRenderFns } from "./WIPSetupPage.vue?vue&type=template&id=70511986&scoped=true&"
import script from "./WIPSetupPage.vue?vue&type=script&lang=js&"
export * from "./WIPSetupPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70511986",
  null
  
)

export default component.exports